import React, { useState, useEffect, useContext } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styled from "styled-components";
import Modal from 'react-bootstrap/Modal';
import ModalBody from "../components/Modal/ModalBody";
import ModalBodyCancel from "../components/Modal/ModalBodyCancel";
import ModalBodyCalendar from "../components/Modal/ModalBodyCalendar";
import Button from 'react-bootstrap/Button';
import { DataContext } from "../context/ContextData";
import Notifications, { notify } from 'react-notify-toast';
import Select from 'react-select';
import { sortBy } from 'lodash';
import moment from 'moment';

const Fabri = ({ title1, title2 }) => {
  const [turnos, setTurnos] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [show, setShow] = useState(false);
  const [showModalCancel, setShowModalCancel] = useState(false);
  const [showModalCalendar, setShowModalCalendar] = useState(false);
  const [search, setSearch] = useState('fecha');
  const [nombreBusqueda, setNombreBusqueda] = useState('');

  const barberoptions = [
    { value: 'Fabricio', label: 'Fabricio' },
  ];

  const busqueda = [
    { value: 'fecha', label: 'Busqueda por Fecha' },
    { value: 'nombre', label: 'Busqueda por Nombre' }
  ];

  const {
    fecha,
    setFecha,
    hora,
    setHora,
    nombre,
    setNombre,
    barbero,
    setBarbero,
    servicio,
    setServicio,
    celular,
    setCelular,
    email,
    setEmail,
    timesToCancel,
    setTimesToCancel,
    dateToCancel,
    setDatesToCancel,
    fechaInicio,
    setFechaInicio,
    fechaFinal,
    setFechaFinal,
    dataEstadisticas,
    setDataEstadisticas
  } = useContext(DataContext);

  const getOptionsForDay = (day) => {
    // Check if it's December 24th, 2024 and 31st, 2024
    const isDecember24And31 = selectedDate.getMonth() === 11 && [24, 31].includes(selectedDate.getDate());


    if (isDecember24And31 && day === 2) { // Special schedule for Tuesday December 24th
      return [
        '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
        '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
        '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
        '19:00'
      ];
    }

    if ([2, 3, 4].includes(day)) { // Regular schedule for other Tuesdays, Wednesdays, Thursdays
      return [
        '14:00', '14:30', '15:00', '15:30', '16:00', '16:30',
        '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
        '20:00', '20:30', '21:00'
      ];
    } else if ([5, 6].includes(day)) { // Viernes, Sábado
      return [
        '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
        '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
        '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
      ];
    } else if (day === 1) { // Lunes (Añadido)
      return [
        '10:00', '10:30', '11:00', '11:30', '12:00', '12:30',
        '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
        '16:00', '16:30', '17:00', '17:30', '18:00', '18:30',
      ];
    }
    return []; // Si no es lunes, domingo u otros días no deseados
  };
  

  const options = getOptionsForDay(selectedDate.getDay());

  function sendData() {
    if (fecha && nombre && barbero && hora && servicio && celular && email) {
      let formData = {
        fecha: fecha,
        nombre: nombre,
        barbero: barbero,
        hora: hora,
        servicio: servicio,
        celular: celular
      };

      let datas = [formData];

      if (servicio === 'Corte y Afeitado') {
        const primero = options.indexOf(hora);
        if (primero < options.length - 1) {
          datas.push({
            fecha: fecha,
            nombre: nombre,
            barbero: barbero,
            hora: options[primero + 1],
            servicio: servicio,
            celular: celular
          });
        } else {
          notify.show('No hay suficiente tiempo para Corte y Afeitado', 'error', 6000);
          return;
        }
      }

      datas.forEach(data => {
        fetch("https://adiosnonino.com/phpindex.php/?insertar=1", {
          method: 'POST',
          body: JSON.stringify(data)
        })
        .then(e => {
          handleClose();
          notify.show('Turno reservado!', 'success', 6000);
        })
        .catch(e => {
          handleClose();
          notify.show('Ha ocurrido un error!', 'error', 6000);
        });
      });
    } else {
      notify.show('Faltan datos!', 'error', 6000);
    }
  }

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const closeModalCancel = () => setShowModalCancel(false);
  const handleShowModalCancel = () => setShowModalCancel(true);
  const handleShowModalCalendar = () => setShowModalCalendar(true);
  const closeModalCalendar = () => {
    setDataEstadisticas(null);
    setShowModalCalendar(false);
  };

  function sendCancelData() {
    timesToCancel.forEach(time => {
      let formData = {
        fecha: dateToCancel,
        nombre: 'cancelado',
        barbero: barbero,
        hora: time,
        servicio: 'Corte',
        celular: 'cancelado'
      };
      fetch("https://adiosnonino.com/phpindex.php/?insertar=1", {
        method: 'POST',
        body: JSON.stringify(formData)
      })
      .then(e => {
        closeModalCancel();
        notify.show('Turno cancelado correctamente', 'success', 6000);
        cargardatos();
      })
      .catch(e => {
        closeModalCancel();
        notify.show('Error al cancelar el turno', 'error', 6000);
      });
    });
  }

  function cargardatos() {
    fetch("https://adiosnonino.com/phpindex.php")
    .then(r => r.json())
    .then(r => setTurnosFabri(r))
    .catch(e => console.log('failed'));
  }

  useEffect(() => {
    setBarbero('Fabricio');
    cargardatos();
  }, []);

  useEffect(() => {
    cargardatos();
  }, [selectedDate, barbero, search, nombreBusqueda]);

  function setTurnosFabri(turnos) {
    if (search === 'fecha') {
      const fechaActual = moment(selectedDate).format('YYYY-MM-DD');
      const turnosFabri = turnos.filter(turno => (turno.barbero === barbero));
      const turnosFabriHoy = turnosFabri.filter(turno => turno.fecha === fechaActual);
      const everyTurnos = options.map(elemento => {
        if (turnosFabriHoy.find(elem => elem.hora === elemento)) {
          return turnosFabriHoy.find(elem => elem.hora === elemento);
        } else {
          return {
            hora: elemento,
            servicio: '',
            nombre: '',
            aclaracion: '',
            celular: ''
          };
        }
      });
      setTurnos(sortBy(everyTurnos, ['hora']));
    } else {
      const coincidencias = turnos.filter(turno => turno.nombre.toUpperCase().includes(nombreBusqueda.toUpperCase()));
      setTurnos(sortBy(coincidencias, ['hora']));
    }
  }

  function cancelarTurno(id) {
    fetch("https://adiosnonino.com/phpindex.php/?borrar=" + id)
    .then(r => cargardatos())
    .catch(e => console.log('failed'));
  }

  function getEstadisticas(id) {
    const formData = {
      fecha_inicio: fechaInicio,
      fecha_final: fechaFinal
    };
    fetch("https://adiosnonino.com/phpindex.php/?estadisticas=1", {
      method: 'POST',
      body: JSON.stringify(formData)
    })
    .then(r => r.json())
    .then(r => setDataEstadisticas(r))
    .catch(e => console.log('failed'));
  }

  return (
    <TurnosContainer>
      <div className="filtros">
        <button onClick={() => handleShow()} type="button" className="btn btn-primary">Agregar Turno</button>
        <button onClick={() => cargardatos()} type="button" className="btn btn-primary">Actualizar</button>
        <Select className="searchclass" defaultValue={busqueda[0]} placeholder="Metodo de Busqueda" options={busqueda} onChange={val => setSearch(val.value)}/>
        {search == 'nombre' && <input className="sarasa" placeholder="Nombre" onChange={e => setNombreBusqueda(e.target.value)} type="text"/>}
        {search == 'fecha' && <Select className="barberclass" defaultValue={barberoptions[0]} placeholder="Barbero" options={barberoptions} onChange={val => setBarbero(val.value)}/>}
        {search == 'fecha' &&<DatePicker
            placeholderText="Fecha"
            className="sarasa sarasapicker ui focus"
            selected={selectedDate}
            onChange={date => setSelectedDate(date)}
            dateFormat='yyyy-MM-dd'
            filterDate={date => date.getDay() !== 0} // Exclude Sunday (0), allow Monday
          />}
        <button onClick={() => handleShowModalCalendar()} type="button" className="btn btn-primary">Estadisticas</button>
        <button onClick={() => handleShowModalCancel()} type="button" className="btn btn-danger">Cancelar Turnos</button>
      </div>
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Hora</th>
            {search == 'nombre' && <th scope="col">Fecha</th>}
            <th scope="col">Servicio</th>
            <th scope="col">Nombre</th>
            <th scope="col">Celular</th>
            <th scope="col">Aclaracion</th>
            <th scope="col">Accion</th>
          </tr>
        </thead>
        <tbody>
        {turnos.length && turnos.map(turno => (
          <tr key={turno.id}>
            <th className={turno.servicio && turno.servicio.split(' ').join('')} scope="row">{turno.hora}</th>
            {search == 'nombre' && <td>{turno.fecha}</td>}
            <td className={turno.servicio && turno.servicio.split(' ').join('')}>{turno.servicio}</td>
            <td className={turno.servicio && turno.servicio.split(' ').join('')}>{turno.nombre}</td>
            <td className={turno.servicio && turno.servicio.split(' ').join('')}>{turno.celular}</td>
            <td className={turno.servicio && turno.servicio.split(' ').join('')}>{turno.aclaracion}</td>
            <td className={turno.servicio && turno.servicio.split(' ').join('')}><button type="button" className="btn btn-danger" onClick={() => cancelarTurno(turno.id)}>Cancelar</button></td>
          </tr>))}
        </tbody>
      </table>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Agenda tu turno</Modal.Title>
        </Modal.Header>
        <Modal.Body>            
          <ModalBody/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={sendData}>
            Reservar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalCancel} onHide={closeModalCancel} centered key="modalCancel">
        <Modal.Header closeButton>
          <Modal.Title>Cancelar Turnos de {barbero}</Modal.Title>
        </Modal.Header>
        <Modal.Body>            
          <ModalBodyCancel/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalCancel}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={sendCancelData}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalCalendar} onHide={closeModalCalendar} centered key="modalCalendar">
        <Modal.Header closeButton>
          <Modal.Title>Estadisticas</Modal.Title>
        </Modal.Header>
        <Modal.Body>            
          <ModalBodyCalendar/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={closeModalCalendar}>
            Cerrar
          </Button>
          <Button variant="primary" onClick={getEstadisticas}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>
    </TurnosContainer>
  );
};

export default Fabri;

const TurnosContainer = styled.div`
  .filtros {
    display: flex;
    align-items: center;
    justify-content: start;
  }

  .CorteyAfeitado {
    background-color: blue
  }

  .Corte {
    background-color: green
  }

  .Afeitado {
    background-color: yellow
  }

  .filtros button {
    margin: 1rem;
    width: 12rem;
  }

  .sarasa {
    padding: .5rem;
    border-radius: .3rem;
  }

  .searchclass {
    width: 20rem;
    margin-right: 1rem;
  }

  .barberclass {
    width: 12rem;
    margin-right: 1rem;
  }

  .sarasa {
    padding: .6rem;
    border-radius: .3rem;
    border-color: #D3D3D3;
    box-shadow: none;
    width: 20rem;
    text-align: center;
  }
`;